(function () {
  var TENNIS_SPORT_ID = '2';

  function clearAndAddDefault(select, defaultText) {
    select.innerHTML = '';
    var opt = document.createElement('option');
    opt.value = '';
    opt.disabled = true;
    opt.selected = true;
    opt.hidden = true;
    opt.textContent = defaultText;
    select.appendChild(opt);
    select.disabled = true;
  }
  function populateLeagues(sportSelector, leagueSelector, teamSelector, oddsetSportsData) {
    var sportId = sportSelector.value;
    var isTennis = sportId === TENNIS_SPORT_ID;

    clearAndAddDefault(leagueSelector, isTennis ? 'Vælg land' : 'Vælg liga');
    clearAndAddDefault(teamSelector, isTennis ? 'Vælg spiller' : 'Vælg hold');

    var sport = oddsetSportsData.find(function (s) { return s.sportId === sportSelector.value; });
    if (sport && sport.leagues && sport.leagues.length > 0) {
      leagueSelector.disabled = false;
      sport.leagues.forEach(function (l) {
        var opt = document.createElement('option');
        opt.value = l.leagueId;
        opt.textContent = l.leagueName;
        leagueSelector.appendChild(opt);
      });
    }
  }

  function updateCalendarButtonsDisabled(isDisabled) {
    var btns = document.querySelectorAll('.calendar-btn');
    var disabledClasses = [
      'bg-button-primary-disabled',
      'text-button-primary-disabled',
      'border-button-primary-disabled',
      'hover:bg-button-primary-disabled',
      'cursor-not-allowed'
    ];
    var enabledClasses = [
      'bg-button-primary',
      'text-button-primary',
      'border-button-primary',
      'hover:bg-button-primary-hover',
      'hover:border-button-primary-hover',
      'cursor-pointer'
    ];
    btns.forEach(function (btn) {
      btn.classList.remove(...enabledClasses);
      if (isDisabled) {
        btn.classList.add(...disabledClasses);
      } else {
        btn.classList.add(...enabledClasses);
        btn.classList.remove(...disabledClasses);
      }
    });
  }

  function handleCalendarButtonClick(type, apiUrl) {
    var sportSelector = document.getElementById('sport-selector');
    var leagueSelector = document.getElementById('league-selector');
    var teamSelector = document.getElementById('team-selector');
    var sportId = sportSelector.value;
    var leagueId = leagueSelector.value;
    var teamId = teamSelector.value;
    if (!leagueId) return;
    var icsUrl;

    var calendarApiUrl = apiUrl.replace(/^https?:\/\//, 'webcal://');

    if (sportId === TENNIS_SPORT_ID) {
      if (teamId !== '0') {
        icsUrl = calendarApiUrl + '/v1/tennis/' + teamId + '.ics';
      } else {
        icsUrl = calendarApiUrl + '/v1/Tournament/' + leagueId + '.ics';
      }
    } else {
      if (teamId !== '0') {
        icsUrl = calendarApiUrl + '/v1/Teams/' + leagueId + '/' + teamId + '.ics';
      } else {
        icsUrl = calendarApiUrl + '/v1/Tournament/' + leagueId + '.ics';
      }
    }

    if (type === 'apple') {
      window.open(icsUrl, '_blank');
    } else {
      var googleUrl = 'https://www.google.com/calendar/r?cid=' + icsUrl;
      window.open(googleUrl, '_blank');
    }
  }

  function setupOddsetCalendarCascading() {
    var container = document.getElementById('oddset-calendar');
    if (!container) return;
    var dataSettings = container.dataset.settings;
    var apiUrl = container.dataset.apiUrl;
    if (!dataSettings || !apiUrl) return;
    var oddsetSportsData;
    try {
      var parsed = JSON.parse(dataSettings);
      oddsetSportsData = parsed.sports;
    } catch (e) {
      return;
    }
    var sportSelector = document.getElementById('sport-selector');
    var leagueSelector = document.getElementById('league-selector');
    var teamSelector = document.getElementById('team-selector');
    if (!sportSelector || !leagueSelector || !teamSelector) return;

    sportSelector.addEventListener('change', function () {
      populateLeagues(sportSelector, leagueSelector, teamSelector, oddsetSportsData);
      updateCalendarButtonsDisabled(true);
    });    leagueSelector.addEventListener('change', function () {
      var sportId = sportSelector.value;
      var isTennis = sportId === TENNIS_SPORT_ID;

      clearAndAddDefault(teamSelector, isTennis ? 'Vælg spiller' : 'Vælg hold');
      var sport = oddsetSportsData.find(function (s) { return s.sportId === sportSelector.value; });
      if (!sport) return;
      var league = sport.leagues.find(function (l) { return l.leagueId === leagueSelector.value; });
      if (league && league.teams && league.teams.length > 0) {
        teamSelector.disabled = false;
        league.teams.forEach(function (t) {
          var opt = document.createElement('option');
          opt.value = t.teamId;
          opt.textContent = t.teamName;
          teamSelector.appendChild(opt);
        });
      }
      updateCalendarButtonsDisabled(true);
    });

    teamSelector.addEventListener('change', function () {
      var isTeamPicked = teamSelector.value !== '';
      updateCalendarButtonsDisabled(!isTeamPicked);
    });

    var appleBtn = document.getElementById('wallet-card-apple');
    var googleBtn = document.getElementById('wallet-card-google');
    if (appleBtn) {
      appleBtn.addEventListener('click', function (e) {
        if (appleBtn.classList.contains('bg-button-primary-disabled')) {
          e.preventDefault();
          return;
        }
        handleCalendarButtonClick('apple', apiUrl);
      });
    }
    if (googleBtn) {
      googleBtn.addEventListener('click', function (e) {
        if (googleBtn.classList.contains('bg-button-primary-disabled')) {
          e.preventDefault();
          return;
        }
        handleCalendarButtonClick('google', apiUrl);
      });
    }

    if (sportSelector.options.length === 1 && sportSelector.value !== '') {
      populateLeagues(sportSelector, leagueSelector, teamSelector, oddsetSportsData);
    }
    updateCalendarButtonsDisabled(true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupOddsetCalendarCascading);
  } else {
    setupOddsetCalendarCascading();
  }
})();
